const getResponsiveEl = (windowWidth, el, keyLG, keyXS) => {
    if (windowWidth < 992) {
      return el?.[keyXS];
    }
    return el?.[keyLG];
  };
  
  export default getResponsiveEl;
  